import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';
import { OrderTypes } from '@/core/enums';

export class ExceptionOrdersResource extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     */
    constructor(apiClient) {
        super(apiClient, 'exceptionOrders');
    }

    getCount(orderType) {
        return this.get(`count/${orderType}`);
    }

    getTypes(orderType) {
        return this.get(`types/${orderType}`);
    }

    deleteExceptions(exceptionIds) {
        const payload = { ExceptionIds: exceptionIds };
        return this.api.delete(`${this.endpoint}`, payload, {});
    }

    processHSCodes(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processHSCodes`, payload, config);
    }

    processInlineException(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processInline`, payload, config);
    }

    processShippingAddress(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processShippingAddress`, payload, config);
    }

    processMissingProductValues(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processMissingProductValues`, payload, config);
    }

    processInvalidLotTrackDetailValues(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processInvalidLotTrackItems`, payload, config);
    }

    processInvalidEmailAddress(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processInvalidEmailAddress`, payload, config);
    }

    processInvalidPhoneNumber(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processInvalidPhoneNumber`, payload, config);
    }

    processManufacturerProductId(payload, config = {}) {
        return this.api.post(`${this.endpoint}/processManufacturerId`, payload, config);
    }

    getExportPath(orderTypeFilter) {
        const bothTypes = !orderTypeFilter || orderTypeFilter === 'reset';
        const orderType = bothTypes ? OrderTypes.Consumer : orderTypeFilter;
        return `${this.api.baseURL}/exceptionOrders/excel?orderType=${orderType}`;
    }
}

export default new ExceptionOrdersResource(api);
